import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// 📥 Importar páginas
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import Perfil from "./pages/Perfil";
import Predashboard from "./components/verificacionExitosa";
import Notificaciones from "./pages/NotificacionesPage";
import Resultados from "./pages/Resultados";
import Usuarios from "./pages/Usuarios";
import TasksAdmin from "./pages/TasksAdmin";
import CountryLabelsAdmin from "./pages/CountryLabelsAdmin";
import AdminScenathon from "./pages/AdminScenathon";
import MainLayout from "./Main/MainLayoud";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiesPolicy from "./pages/CookiesPolicy";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PathwayPage from "./pages/Pathways";
import ScenariosPage from "./pages/Scenarios";
import ComparisonPage from "./pages/Comparison";
import ScenathonsPage from "./pages/Scenathon";
import ScenathonLobby from "./pages/ScenathonLobby";
import TradeAdjustmentPage from "./pages/TradeAdjustment";
import FairsharePage from "./pages/Fairshare";
import { NotificationsProvider } from "./components/Notificaciones/NotificationsContext";

// 📥 Importar Auth
import { AuthProvider } from "./auth/AuthContext";
import RequireAuth from "./auth/RequireAuth";
import RequireRole from "./auth/RequireRole"; // 🆕 NUEVO
import Chat from "./components/Chat";

import "./App.css";

// Wrapper para pasar headerText al layout
function LayoutWrapper({ headerText }) {
  return <MainLayout headerText={headerText} />;
}

function App() {
  return (
    <AuthProvider>
      <NotificationsProvider>
        <BrowserRouter>
          <Routes>
            {/* ========================================
                🟢 RUTAS PÚBLICAS (sin autenticación)
                ======================================== */}
            <Route path="/" element={<Login />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/predashboard" element={<Predashboard />} />
            <Route path="/terminos" element={<TermsAndConditions />} />
            <Route path="/privacidad" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiesPolicy />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* ========================================
                🔒 RUTAS PROTEGIDAS (requieren token)
                ======================================== */}

            {/* Rutas para TODOS los usuarios autenticados */}
            <Route element={<RequireAuth />}>
              {/* Profile y Notifications - accesibles por todos */}
              <Route element={<LayoutWrapper headerText="Profile" />}>
                <Route path="/perfil" element={<Perfil />} />
              </Route>

              <Route element={<LayoutWrapper headerText="Notifications" />}>
                <Route path="/notificaciones" element={<Notificaciones />} />
              </Route>

              {/* Scenathon - accesible por todos */}
              <Route element={<LayoutWrapper headerText="Welcome to Scenathon Platform" />}>
                <Route path="/scenathon" element={<ScenathonsPage />} />
              </Route>

              <Route path="/lobby" element={<ScenathonLobby />} />

              {/* AI Assistant - accesible por todos */}
              <Route element={<LayoutWrapper headerText="AI Assistant" />}>
                <Route path="/ai-assistant" element={<Chat isFullPage={true} />} />
              </Route>

              {/* Trade Adjustment - accesible por todos */}
              
            </Route>

            <Route
              element={
                <RequireAuth />
              }
            >
              <Route
                element={
                  <RequireRole
                    requiredRoles={["organizer", "admin"]}
                  />
                }
              >

              </Route>
              <Route element={<LayoutWrapper headerText="Trade Adjustment" />}>
                <Route path="/trade-adjustment" element={<TradeAdjustmentPage />} />
              </Route>

              <Route element={<LayoutWrapper headerText="Fairshare" />}>
                <Route path="/fairshare" element={<FairsharePage />} />
              </Route>
              </Route>

            {/* ========================================
                👥 RUTAS POR ROL: ORGANIZER, TEAMLEADER, COUNTRYTEAM
                ======================================== */}
            <Route
              element={
                <RequireAuth />
              }
            >
              <Route
                element={
                  <RequireRole
                    requiredRoles={["organizer", "teamleader", "countryteam"]}
                  />
                }
              >
                <Route element={<LayoutWrapper headerText="Create Pathway" />}>
                  <Route path="/pathways" element={<PathwayPage />} />
                </Route>

                <Route element={<LayoutWrapper headerText="Create Scenarios" />}>
                  <Route path="/scenarios" element={<ScenariosPage />} />
                </Route>

                <Route element={<LayoutWrapper headerText="Pathway Comparison" />}>
                  <Route path="/comparison" element={<ComparisonPage />} />
                </Route>

                <Route element={<LayoutWrapper headerText="Results" />}>
                  <Route path="/results" element={<Resultados />} />
                </Route>
              </Route>
            </Route>

            {/* ========================================
                🛡️  RUTAS SOLO PARA ADMIN
                ======================================== */}
            <Route element={<RequireAuth />}>
              <Route element={<RequireRole requiredRoles="admin" />}>
                <Route element={<LayoutWrapper headerText="Users" />}>
                  <Route path="/users" element={<Usuarios />} />
                </Route>
                <Route element={<LayoutWrapper headerText="Tasks" />}>
                  <Route path="/admin/tasks" element={<TasksAdmin />} />
                </Route>
                <Route element={<LayoutWrapper headerText="Country Labels" />}>
                  <Route path="/admin/country-labels" element={<CountryLabelsAdmin />} />
                </Route>
              </Route>
            </Route>

            <Route element={<RequireAuth />}>
              <Route element={<LayoutWrapper headerText="Admin Scenathon" />}>
                <Route path="/admin/scenathon" element={<AdminScenathon />} />
              </Route>
            </Route>

            {/* ========================================
                404: Ruta no encontrada
                ======================================== */}
            <Route path="*" element={<div>Page not found</div>} />
          </Routes>
        </BrowserRouter>
      </NotificationsProvider>
    </AuthProvider>
  );
}

export default App;